// Mirrors the badge condition in ControlItem: the shared `count` renders on the active
// item only, so an item's width depends on which item is active.
export const getWidthSignature = ({ items, activeValue, count, loading }) =>
  JSON.stringify(
    items.map((item) => {
      const badge = loading ? 0 : item.count || (item.value === activeValue && count);

      return [item.value, item.label, item.icon, badge || 0];
    })
  );
